import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { MdbTableDirective, ModalDirective } from 'angular-bootstrap-md';
import { AlertService } from 'ngx-alerts';
import { ExcelService } from '../excel.service';
import { FacturaService } from '../factura.service';
import { FacturaXls } from '../FacturaXls';
import Swal from 'sweetalert2';
import { DatePipe } from '@angular/common';
import { CajaService } from '../caja.service';
@Component({
  selector: 'app-factura-xls',
  templateUrl: './factura-xls.component.html',
  styleUrls: ['./factura-xls.component.css']
})
export class FacturaXlsComponent implements OnInit {
  listaFacturas: FacturaXls[] = [];
  listaDetalle: FacturaXls[] = [];
  listaEmail: FacturaXls[] = [];
  facturaXls: FacturaXls;
  private alertService: AlertService;
  searchText: string = '';
  @HostListener('input') oninput() {
    this.searchItems();
  }
  fecha: string;
  previous: any = [];
  constructor(private excelSrv: ExcelService,

    private cajaServicio: CajaService,
    private datePipe: DatePipe, private apiFac: FacturaService) { }

  numeroDocumento: string;

  cliente: string;
  @ViewChild(MdbTableDirective) mdbTable: MdbTableDirective
  @ViewChild("DetalleModal") public DetalleModal: ModalDirective;
  ngOnInit(): void {
    this.listarEmail();
  }


  listarEmail() {
    this.apiFac.listarEmail
      ()
      .subscribe((
        data: FacturaXls[]) => {

        this.listaEmail = data;
      },
      );


  }
  searchItems() {
    const prev = this.mdbTable.getDataSource();


    if (this.searchText) {
      this.listaFacturas = this.mdbTable.searchLocalDataBy(this.searchText);
      this.mdbTable.setDataSource(prev);
      this.mdbTable.dataSourceChange
    }
  }
  downloadPDF(fac: FacturaXls) {
    console.log(fac.ruta)
    window.open('../../' + fac.ruta, '_blank');
  }

  editar(numero) {
    this.apiFac.listaFacturasNumDocXls
      (numero)
      .subscribe((
        data: FacturaXls[]) => {

        this.listaDetalle = data;
        this.mdbTable.setDataSource(this.listaDetalle);
        this.DetalleModal.show();

      },
        err => this.alertService.danger('Error no hay  conexion..')
      );


  }

  eliminar(numero) {
    Swal.fire({
      title: "Alerta...",
      text: "¿Está seguro de eliminar esta factura?",
      icon: "warning",
      showCancelButton: true,  // Añadir un botón de cancelación
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
    })
      .then((result) => {
        if (result.isConfirmed) {
          // El usuario hizo clic en "Aceptar"
          this.apiFac.eliminarFacturaXls(numero).subscribe(
            (data: FacturaXls[]) => {
              // Éxito al eliminar
              Swal.fire("Éxito", "Se eliminó con éxito.", "success");
              this.listaFacturas = [];
              this.buscar();  // Vuelve a buscar las facturas
            },
            (error) => {
              // Error al eliminar
              Swal.fire("Error", "No se pudo eliminar la factura.", "error");
            }
          );
        } else {
          // El usuario hizo clic en "Cancelar" o cerró la alerta
          Swal.fire("Cancelado", "La operación de eliminación fue cancelada.", "info");
        }
      });


  }
  guardarXls() {

    Swal.fire({
      title: "Alerta....",
      text: "Esta seguro de guardar las Facturas",
      icon: "warning",
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
    })
      .then((result) => {
        if (result.isConfirmed) {
          this.apiFac.setActulizarFacturaXls(this.listaFacturas).subscribe(
            (data: FacturaXls[]) => {
              Swal.fire("Se guardo con existo..");
              this.listaFacturas = [];


            },
            error => {
              Swal.fire("No se puede guardar..");

            }

          );
        } else {

        }
      });

  }


  facturaElectronicaXls() {
    Swal.fire({
      title: "Alerta....",
      text: "Esta seguro procesar Facturas",
      icon: "warning",

      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
    })
      .then((result) => {
        if (result.isConfirmed) {
          this.apiFac.confirmarFacturaXls(this.datePipe.transform(this.fecha, "dd-MM-yyyy")).subscribe(
            (data: FacturaXls[]) => {
              Swal.fire("Se envio con existo..");
              this.listaFacturas = [];
              this.mdbTable.setDataSource(this.listaFacturas);

            },
            error => {
              Swal.fire("No se puede enviar.....");

            }

          );
        } else {

        }
      });

  }
  buscar() {

    this.apiFac.listaFacturasAgupadasXls
      (this.datePipe.transform(this.fecha, "dd-MM-yyyy"))
      .subscribe((
        data: FacturaXls[]) => {

        this.listaFacturas = data;
        this.mdbTable.setDataSource(this.listaFacturas);
        this.mdbTable.dataSourceChange();

        this.previous = this.mdbTable.getDataSource();

      },
        err => this.alertService.danger('Error no hay  conexion..')
      );
  }


  onChangeFecha(newObj) {
    this.fecha = newObj

  }


  onFileChange(evt: any) {
    this.listaFacturas = [];
    this.mdbTable.setDataSource(this.listaFacturas);
    this.mdbTable.dataSourceChange();
    let valida: number = 0;
    if (this.fecha) {

      const target: DataTransfer = <DataTransfer>(evt.target);

      if (target.files.length !== 1) throw new Error('Cannot use multiple files');

      const reader: FileReader = new FileReader();
      reader.readAsBinaryString(target.files[0]);
      reader.onload = (e: any) => {

        const bstr: string = e.target.result;
        const data = <any[]>this.excelSrv.importFromFile(bstr);
        for (let i = 2; i < data.length; i++) {
          let row = data[i];
          //Factura
          ///if (row.length == 29) {
          if (row[0] === 'Fec') {
            // this.fecha=row[1];
            this.numeroDocumento = row[3];
            this.cliente = row[5];
            valida = 1;
          }
          //datos
          if (
            this.isValidField(row[1]) &&
            this.isValidField(row[2]) &&
            this.isValidField(row[6]) &&
            this.isValidField(row[7])
          ) {
            // if (row.length == 21) {
            if (row[1] != 'Id') {
              this.facturaXls = new FacturaXls();
              this.facturaXls.id = 0;
              this.facturaXls.fecha = this.fecha;
              this.facturaXls.numeroDoc = this.numeroDocumento;
              const clientes = this.cliente.split("-", this.cliente.length);
              this.facturaXls.cedula = clientes[0].trim();
              this.facturaXls.cliente = clientes[1].trim();
              this.facturaXls.codigo_producto = row[1];
              this.facturaXls.producto = row[2];
              this.facturaXls.iva = row[19];
              this.facturaXls.pvp = row[15];
              this.facturaXls.cantidad = 1;
              this.facturaXls.idEmisor = Number.parseInt(localStorage.getItem('id'));
              const fact = this.listaEmail.find((p) => { return p.cedula == this.facturaXls.cedula })
              this.facturaXls.email = fact?.email;
              this.listaFacturas.push(this.facturaXls);
            }
            valida = 0;
          }
        }
      }
      console.log(this.listaFacturas);
      this.mdbTable.setDataSource(this.listaFacturas);
      this.mdbTable.dataSourceChange();
      Swal.fire("Se cargo con exito...")

    } else {
      Swal.fire('Debe seleccionar la fecha..')
    }
  }

  private isValidField(value: any): boolean {
    return value !== undefined && value !== null && value !== "";
  }

}

